module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hNig6L/tc-custom/9783968653457.jpg",
      "alt": "This image is the cover for the book Der verhängnisvolle Brief, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Der verhängnisvolle Brief, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dieser 1916 auf deutsch veröffentlichte Kriminalroman stammt vom Sohn des bedeutenden Dichters Nathaniel Hawthorne, Julian Hawthorne. Maxwell Golding, ein skrupelloser New Yorker Milliardär wird in einem anonym verfassten Brief bedroht. Die Zeit läuft ab und Inspektor Byrnes greift ein...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julian Hawthorne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Julian Hawthorne (June 22, 1846 – July 14, 1934) war ein amerikanischer Schriftsteller und Journalist. Er war der Sohn  von Hawthorne und Sophia Peabody. Er schrieb zahlreiche Gedichte, Romane , Kurzgeschichten und Mystery/Detektivgeschichten.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTBeBook Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4cb4cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0